import { useMemo } from "react";
import { get } from "lodash";
import { useQuery } from "@tanstack/react-query";

import { queryClient } from "App";
import { addResizedColumns } from "./useTableConfig";
import { REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS } from "routes/revenue_opportunity_recipient_presets/RevenueOpportunityRecipientPresetsTableV3";
import UserService from "services/User";
import {
  getRevenueOpportunityRecipientPresetsTableColumns,
  getRevenueOpportunityRecipientPresetsTableFilters,
} from "routes/revenue_opportunity_recipient_presets/RevenueOpportunityRecipientPresetsTableColumnsAndFilters";

export const invalidateRevenueOpportunityRecipientPresetsTableQuery =
  async () => {
    await queryClient.invalidateQueries({
      queryKey: [
        REVENUE_OPPORTUNITY_RECIPIENT_PRESETS_TABLE_CONSTANTS.queryKey,
      ],
    });
  };

export const useRevenueOpportunityRecipientPresetsTable = ({ tableName }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const filters = useMemo(() => {
    return getRevenueOpportunityRecipientPresetsTableFilters();
  }, []);

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getRevenueOpportunityRecipientPresetsTableColumns();

    const presetsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: presetsTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableName, tableSettings, isTableSettingsFetched]);

  return { filters, columns };
};
